import { Component, type ReactNode, Suspense, useMemo } from 'react'
import { getPlaceholderComponent, getStoryComponent } from '../utils/parsedTree.js'
import { useStoryRoute } from './hooks/useStoryRoute.js'
import { PreviewFallback } from './PreviewFallback.js'
import classes from './preview.module.css'

export function Preview() {
  const { story: activePreview } = useStoryRoute()

  const SandboxOutlet = useMemo(() => {
    const Placeholder = getPlaceholderComponent()
    const PreviewComponent = activePreview ? getStoryComponent(activePreview) : Placeholder
    return PreviewComponent ?? Placeholder
  }, [activePreview])

  return (
    <div className={classes.root} data-testid="tidal-sandbox_preview">
      <ErrorBoundary>
        <Suspense fallback={<PreviewFallback />}>
          <SandboxOutlet />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}

type ErrorBoundaryProps = {
  children: ReactNode
}

type ErrorBoundaryState = {
  hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch() {
    this.setState({ hasError: true })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '8px' }}>
          <h2>Something went wrong. See the console for error info</h2>
        </div>
      )
    }

    return this.props.children
  }
}
